import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import type { Dayjs } from 'dayjs';
import { Airport } from '../../models';
import { StationSelectorComponent } from '../station-selector/station-selector.component';
import { NgClass, DatePipe } from '@angular/common';
import { DropDownV2Component } from '../dropdown-v2/dropdown-v2.component';

@Component({
    selector: 'emt-common-header',
    templateUrl: './common-header.component.html',
    styleUrls: ['./common-header.component.scss'],
    imports: [
        StationSelectorComponent,
        NgClass,
        DropDownV2Component,
        DatePipe,
    ],
})
export class CommonHeaderComponent implements OnInit {
  @Input() stationName: string;
  @Input() tabOptions: Array<{ label: string; route: string }>;
  @Input() dataUpdated: any;
  @Input() dataUpdatedOffset: string;
  @Input() activeTab: string;
  @Input() dropdownControl: FormControl;
  @Input() dropdownOptions: Array<object>;
  @Input() dropdownPlaceholder: string;
  @Input() dropdownBindLabel: string;
  @Input() dropdownBindValue: string;
  @Input() airports: Airport[];
  @Input() showStationSelector = false;
  @Output() refreshClicked = new EventEmitter();
  @Output() tabClicked = new EventEmitter();
  @Input() showDate: boolean;
  public todaysDate = new Date();

  constructor() {}

  ngOnInit() {}
}
